import type { ReactNode } from 'react';

export interface EmptyStateProps {
  title: string;
  description?: string;
  action?: ReactNode;
  icon?: ReactNode;
}

export function EmptyState({ title, description, action, icon }: EmptyStateProps) {
  return (
    <div className="u-empty">
      {icon ? <div aria-hidden="true">{icon}</div> : null}
      <h3 className="u-empty__title">{title}</h3>
      {description ? <p className="u-empty__description">{description}</p> : null}
      {action}
    </div>
  );
}
